import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect } from "react";
import { Field, Formik } from 'formik';
import { Container, Row, Col } from 'react-bootstrap';
import Wrapper from '../../wrapper/Wrapper';
import Modal from '../../modal/Modal';
import { FormInput, FormControlledInput, FormSelect, StateBootstrapButton as StateButton } from '../../forms/elements';
import { returnsFormikEnhancer } from "./formik/returnsFormikEnahncer";
import { connect, ReactReduxContext } from 'react-redux';
import { OrderStatusField } from './RetailGuestForm';
import { Quantity } from "../../cart/CartHelpers";
import * as UTIL from "../../../util"; // Redux

import { accountDuck } from "../../../ducks/account";
import MediaQuery from "react-responsive";
var accountOperations = accountDuck.operations;
export var ReturnsModalForm = function ReturnsModalForm(props) {
  var _props$setFieldTouche = props.setFieldTouched,
      setFieldTouched = _props$setFieldTouche === void 0 ? function () {
    return "";
  } : _props$setFieldTouche,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      _props$handleSubmit = props.handleSubmit,
      handleSubmit = _props$handleSubmit === void 0 ? function () {
    return "";
  } : _props$handleSubmit,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? {} : _props$errors,
      _props$values = props.values,
      values = _props$values === void 0 ? {} : _props$values,
      _props$show = props.show,
      show = _props$show === void 0 ? function () {
    return console.log("SHOW");
  } : _props$show,
      _props$hide = props.hide,
      hide = _props$hide === void 0 ? function () {
    return console.log("HIDE");
  } : _props$hide,
      toReturn = props.toReturn,
      success = props.success;

  var _ref = toReturn || {},
      qty = _ref.Quantity;

  var onClick = function onClick() {
    setFieldTouched("number", true);
    setFieldTouched("reason", true);

    if (!Object.keys(errors).length) {
      handleSubmit(values, {
        props: props
      });
    }
  };

  useEffect(function () {
    setFieldValue("number", 1);
  }, [setFieldValue]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    hide: hide // Return/
    ,
    title: "Refund",
    className: "cb-returns-modal"
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Row, null, !success ? /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ReturnType, null), /*#__PURE__*/React.createElement(ReturnDropdown, props), /*#__PURE__*/React.createElement("p", null, "Quantity to Return"), /*#__PURE__*/React.createElement(Quantity, {
    value: (values === null || values === void 0 ? void 0 : values.number) || 1,
    min: 1,
    max: qty,
    onChange: function onChange(e) {
      return setFieldValue("number", e);
    }
  }), /*#__PURE__*/React.createElement(OrderStatusField, _extends({
    label: "Comments (optional)",
    name: "comments",
    className: "mt-16"
  }, props)), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(StateButton, {
    type: "submit",
    className: "cb-button-primary",
    onClick: onClick
  }, "Submit")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(StateButton, {
    type: "button",
    className: "cb-button-secondary",
    onClick: hide
  }, "Close")))), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(StateButton, {
    type: "submit",
    className: "cb-button-primary",
    onClick: onClick
  }, "Submit"), /*#__PURE__*/React.createElement(StateButton, {
    type: "button",
    className: "cb-button-secondary",
    onClick: hide
  }, "Close"))))) : /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h2", null, "Return started successfully"), /*#__PURE__*/React.createElement("p", {
    className: "mt-16"
  }, "To complete your return, go to UPS to create a shipping label"), /*#__PURE__*/React.createElement("form", {
    method: "POST",
    action: "https://row.ups.com/GuestAccess/Guest/Access",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "Company",
    value: "Q0I="
  }), /*#__PURE__*/React.createElement(StateButton, {
    type: "submit",
    className: "cb-button-secondary mt-16",
    onClick: function onClick(e) {
      hide(e);
    }
  }, "Create Shipping Label"))))))));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account;

  return {
    toReturn: state.account.toReturn,
    success: (_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.successReturn
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    postGuestReturn: function postGuestReturn(orderObj) {
      return dispatch(accountOperations.postReturnOrder(orderObj));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(returnsFormikEnhancer(ReturnsModalForm));

var ReturnDropdown = function ReturnDropdown(_ref2) {
  var values = _ref2.values,
      setFieldValue = _ref2.setFieldValue;
  return /*#__PURE__*/React.createElement(Field, {
    value: values === null || values === void 0 ? void 0 : values.reason,
    name: "reason",
    label: "Reason of Return",
    hideLabel: true,
    component: FormSelect,
    options: [{
      "label": "Reason of Return",
      "value": ""
    }, {
      "label": "Damaged",
      "value": "damaged"
    }, {
      "label": "Different Expectations",
      "value": "differentExpectation"
    }, {
      "label": "Late",
      "value": "late"
    }, {
      "label": "Missing Parts",
      "value": "missingParts"
    }, {
      "label": "No Longer Wanted",
      "value": "noLongerWanted"
    }, {
      "label": "Other",
      "value": "other"
    }],
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      setFieldValue("reason", e.currentTarget.value);
    }
  });
};

var ReturnType = function ReturnType() {
  return /*#__PURE__*/React.createElement("div", null);
};